import { API_URL } from './constants';

export interface McpAdminTokenDto {
  aliasId: string;
  clientName: string;
  clientId: string;
  scopes: string[];
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string;
  userId: number;
  userEmail: string;
}

export interface ApiMcpTokensListResponse {
  tokens: McpAdminTokenDto[];
  total: number;
}

export async function apiAdminMcpTokensList(
  params: { limit: number; offset: number },
  token: string,
): Promise<ApiMcpTokensListResponse | null> {
  const url = new URL(
    `${API_URL}/admin/mcp/tokens?limit=${params.limit}&offset=${params.offset}`,
  ).href;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 200) {
    return (await response.json()) as ApiMcpTokensListResponse;
  }
  return null;
}

export async function apiAdminMcpTokenRevoke(
  aliasId: string,
  token: string,
): Promise<boolean> {
  const url = new URL(`${API_URL}/admin/mcp/tokens/${aliasId}`).href;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.status === 200 || response.status === 204;
}
